export interface IUserLookup {
    Id: number
    Username: string
    FirstName: string
    LastName: string
    FullName: string
}

export interface ILoginResult {
    success: boolean;
    message: string;
    response: ILoginReponse;
}

export interface ILoginReponse {
    resetPassword: boolean;
    user: ILoginResponseUser;
    reset_token: string;
    Companies: string[];
    CompanyList: string[];
    Roles: string[];
    LicProducts: string[];
    LicProductsList: { [key: string]: number };
    Id: number;
    UserType: number;
    Username: string;
    FirstName: string;
    LastName: string;
    FullName: string;
    Email: string;
    Phone: string;
    ParticipantId: number;
    CultureId: number;
    CultureName: string;
    CultureCode: string;
    RoleId: number;
    agreedToPrivacyStatement: boolean;
    PrivacyStatementDate: Date;
    UnknownParticipant: boolean;
    LastLoggedInDate: Date;
}

export interface ILoginResponseUser {
    login_attempts: number;
    reason_code: number;
    locked_reason: number;
    FirstName: string
    LastName: string
    Email: string
    privacy_statement: boolean
    privacy_gdpr: boolean
    UserType: number
    ParticipantID: number
    UserID: number
    ParticipantCultureId: number
    Culture: string
    CultureId: number
    CultureName: string
    user_token: string
    loginAttempts: number
    username: string
    Roles: string[];
    Companies: string[];
    RedirectUrl: string;
    PQPId: number;
}

export interface ILoginDispatch {
    id: number;
    type: number;
    role: number;
    roleName?: string;
    participantId: number;
    participantLanguageId: number;
    username: string;
    firstName: string;
    lastName: string;
    fullName: string;
    languageId: number;
    user_token: string;
    email: string;
    redirect: IRedirectInfo;
    unknownParticipant?: boolean;
}

export interface IRedirectInfo {
  submitRedirect: string;
  assessmentRedirect: number;
}

export interface ILoginData {
    username: string;
    password: string;
}

export interface IReduxDispatchable<T> {
    type: string,
    payload: T
}

export enum KeyType {
    Enter
}

export interface ITokenCheckResponse {
    userId: number
    membershipID: number
    username: string
    isNewUser: boolean
    isTokenValid: boolean
    isTokenExpired: boolean
    message: string
    usertype: number
    culturecode: string
}
